import { CalcProductLogic } from "@biz/items/CalcProductLogic";
import { CalcCurtainLogic } from "@biz/items/curtain/CalcCurtainLogic";
import { Curtain2dLogic } from "@biz/items/curtain/Curtain2dLogic";
import { ICurtain2dForm } from "@biz/items/curtain/CurtainDefinitions";
import { CurtainLogic } from "@biz/items/curtain/CurtainLogic";
import { FieldErrorMap } from "@biz/models/FieldErrorMap";
import { IShoppingArticleOptions } from "@biz/models/ShoppingListDefinitions";
import { PD } from "@biz/PD";
import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";

export class CalcCurtain2dLogic {
  static calc2d(curtain: ICurtain2dForm, slc: ICalcContext): ICalculatedProductResult {
    // const { lc, articleMap, colorMap } = slc;

    if (curtain.productType !== "curtain2d")
      throw new Error("Product2dForm supports curtains only!!!")

    // const product: ICurtainData | undefined = CurtainData.createEmpty(curtain.curtainType, Vec3.ZERO, slc.articleMap, slc.colorMap, { id: curtain.id });

    const guides = Curtain2dLogic.calcGuides(curtain)
    if (guides.length > 0) {
      for (const g of guides) {
        CalcCurtainLogic.addGuideInfoArticles(slc, g);
      }
    }

    const ropes = Curtain2dLogic.calcRopes(curtain);
    if (ropes.length > 0) {
      const optionsRopeMount: Partial<IShoppingArticleOptions> = {
        idCategory: "additional",
        partList: { group: "Warenkorb" },
        articleGroup: "curtainRopeMount"
      }

      for (const r of ropes) {
        CalcCurtainLogic.addCurtainRope(slc, r, optionsRopeMount);
      }
    }

    const clothInfos = Curtain2dLogic.calcClothInfos(curtain);
    CalcCurtainLogic.calcClothArticlesFromClothInfos(slc, clothInfos);

    if (curtain.extraTieBacks?.length > 0) {
      for (const tieBack of curtain.extraTieBacks) {
        const tieBackType = Curtain2dLogic.getTieBackType(curtain, undefined);
        CalcCurtainLogic.addTieBackArticle(slc, tieBack.count, tieBackType, tieBack.length,
          Curtain2dLogic.getClothGroup(curtain, undefined),
          Curtain2dLogic.getClothColorId(curtain, undefined),
          {});
      }
    }

    {
      const suspensionCount = Curtain2dLogic.getClothSuspensionCount(curtain);
      const suspensionType = Curtain2dLogic.getClothSuspensionType(curtain, undefined);
      const articleNumber = CurtainLogic.getArticleNumberForSuspensionType(suspensionType)
      if (articleNumber) {
        CalcProductLogic.addRuleArticle(slc, articleNumber, { count: suspensionCount, partList: { list: "stockList", group: "Warenkorb" }, idCategory: "curtainSuspensionArticles", quickCategory: "curtainAdditional", articleGroup: "curtainSuspension", });
      }
    }

    // track articles
    {
      const options: Partial<IShoppingArticleOptions> = { count: 0, articleType: "optional", partList: { list: "stockList", group: "Warenkorb" }, idCategory: "curtainTrackArticles" }
      CalcCurtainLogic.addCurtainMountArticles(slc, curtain.curtainType, "2d", options);
    }

    // cloth articles
    {
      const options: Partial<IShoppingArticleOptions> = { count: 0, articleType: "optional", partList: { list: "stockList", group: "Warenkorb" }, idCategory: "curtainClothArticles", quickCategory: "curtainAdditional" }
      CalcCurtainLogic.addCurtainClothAdditionalArticles(slc, curtain.curtainType, "2d", options)
    }

    CalcCurtainLogic.calcCurtainErrors(slc);

    CalcProductLogic.finalizeCalcContext(slc, { incomplete: !curtain, defaultOfferList: "S", count: 1 }); //  custom articles
    return {
      id: curtain.id,
      pd: PD.productToPD(curtain),
      infos: slc.infos,
      errors: slc.errors,
      errorMap: FieldErrorMap.errorMapFromErrors(slc.errors || []),
      articles: slc.ruleArticles,
      product: curtain,
      // modified: curtain
    };
  }
}